import { render, staticRenderFns } from "./ComponentAdminImportNurseryXLS.vue?vue&type=template&id=5830ed83&scoped=true"
import script from "./ComponentAdminImportNurseryXLS.vue?vue&type=script&lang=js"
export * from "./ComponentAdminImportNurseryXLS.vue?vue&type=script&lang=js"
import style0 from "./ComponentAdminImportNurseryXLS.vue?vue&type=style&index=0&id=5830ed83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5830ed83",
  null
  
)

export default component.exports